export default "__VITE_ASSET__3A48qxto__"